'use client'

import type { ZodType } from 'zod'

import { http } from '@/core/lib/fetcher/index.client'

import type { CachePolicyInput } from '@/core/lib/cache/cache.policy'
import { FetchError, type FetcherResponse } from '@/core/lib/fetcher/core'
import {
  STANDARD_READ,
  type RequestPolicy,
} from '@/core/lib/fetcher/request-policy'

import { type SwrKey } from './swr.key'

// 키 계산은 swr.key.ts가 권위다(서버 hydrate와 공유). 여기서는 재수출만 한다.
export {
  buildSwrCacheKey,
  createPublicSwrScope,
  createSessionSwrScope,
  getSwrRequestPolicy,
  getSwrScopeIdentity,
  serializeSwrCacheKey,
} from './swr.key'
export type {
  PublicSwrScope,
  SessionSwrScope,
  SwrCacheKey,
  SwrKey,
  SwrScope,
} from './swr.key'

export async function swrFetcher<T>(
  key: SwrKey,
  policy: CachePolicyInput = 'REALTIME',
  readPolicy: RequestPolicy = STANDARD_READ,
  responseSchema?: ZodType<T>
): Promise<FetcherResponse<T>> {
  if (typeof key === 'string') {
    const response = await http.get<T>(key, {
      authScope: 'public',
      cache: policy,
      requestPolicy: readPolicy,
      responseSchema,
    })
    if (!response.ok) throw new FetchError(response)
    return response
  }

  const [url, options] = key
  const authScope = options.scope.kind
  const response = await http.get<T>(url, {
    authScope,
    cache: policy,
    withToast: options.withToast ?? false,
    requestPolicy: options.requestPolicy ?? readPolicy,
    responseSchema,
  })
  if (!response.ok) throw new FetchError(response)
  return response
}
